import { useTranslation } from '@/hooks/useTranslation';

/**
 * LAX-10148 placeholder. LAX-10151 replaces this with the queued/scheduled
 * publications grid (cancel + refresh).
 */
const ScheduledJobsGrid = () => {
    const { t } = useTranslation();

    return (
        <div data-testid="scheduled-jobs-grid" className="tw-mb-4">
            <h2 className="tw-font-bold tw-mt-1 tw-mb-1">
                {t('PUBLICATIONS.SCHEDULED')}
            </h2>
        </div>
    );
};

ScheduledJobsGrid.displayName = 'ScheduledJobsGrid';

export { ScheduledJobsGrid };
